<template>
  <WhyChooseMagnumDental />
</template>

<script>
import WhyChooseMagnumDental from "@/components/why-choose-magnum-dental.vue";
import { useHead } from "@vueuse/head";

export default {
  name: "WhyChooseUs",
  components: {
    WhyChooseMagnumDental,
  },
  setup() {
    useHead({
      title: "Why Choose Magnum Dental Clinic Guwahati | Trusted & Expert Care",
      meta: [
        {
          name: "description",
          content:
            "Discover why patients across Guwahati trust Magnum Dental Clinic — experienced dentists, advanced equipment, strict sterilisation protocols, and personalised dental care.",
        },
        {
          name: "robots",
          content: "index, follow",
        },
        {
          property: "og:title",
          content: "Why Choose Magnum Dental Clinic Guwahati | Trusted & Expert Care",
        },
        {
          property: "og:url",
          content: "https://www.magnumdentalguwahati.in/trusted-dental-clinic-in-guwahati",
        },
      ],
      link: [
        { rel: "canonical", href: "https://www.magnumdentalguwahati.in/trusted-dental-clinic-in-guwahati" },
      ],
    });
  },
};
</script>
